import { render, staticRenderFns } from "./Addproperty.vue?vue&type=template&id=06073ec8&scoped=true"
import script from "./Addproperty.vue?vue&type=script&lang=js"
export * from "./Addproperty.vue?vue&type=script&lang=js"
import style0 from "./Addproperty.vue?vue&type=style&index=0&id=06073ec8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06073ec8",
  null
  
)

export default component.exports